import React, { useState } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Card,
    CardContent,
    Box,
    Stack,
    IconButton,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ModalEditarPregunta from '../catalogos/modales/ModalEditarPregunta';
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';

const DashboardPuntosInspeccion = ({ puntosInspeccion, refresh }) => {
    const [expandedFormulario, setExpandedFormulario] = useState(null);
    const [expandedTema, setExpandedTema] = useState(null);
    const [open, setOpen] = useState(false);
    const [selectedPregunta, setSelectedPregunta] = useState(null);
    const [imagenTema, setImagenTema] = useState(null);

    const handleClose = () => {
        setOpen(false);
        setSelectedPregunta(null);
        setImagenTema(null);
    };

    const handleFormularioChange = (formularioId) => (event, isExpanded) => {
        setExpandedFormulario(isExpanded ? formularioId : null);
        setExpandedTema(null); // Reinicia tema al cambiar formulario
    };

    const handleTemaChange = (temaId) => (event, isExpanded) => {
        setExpandedTema(isExpanded ? temaId : null);
    };

    const handleEditPregunta = (pregunta, imagenUrl, tema) => {
        let objPregunta = { ...pregunta, tema: tema.id_tema, tipo_tema: tema.tipo_tema };
        setSelectedPregunta(objPregunta);
        setImagenTema(imagenUrl);
        setOpen(true);
    };

    const handleDeletePregunta = async (pregunta) => {
        Swal.fire({
            icon: 'warning',
            title: '¿Estás seguro de eliminar la pregunta?',
            text: 'Esta acción no se puede deshacer',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí',
            cancelButtonText: 'No',
            showLoaderOnConfirm: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await myApi.post(`/inspeccion/preguntas/deletePregunta`, { id_pregunta: pregunta.id_pregunta });
                    if (response.data.success) {
                        Swal.fire({ icon: 'success', title: 'Pregunta eliminada' });
                        await refresh();
                    } else {
                        Swal.fire({ icon: 'error', title: 'Error al eliminar pregunta' });
                    }
                } catch (e) {
                    Swal.fire({ icon: 'error', title: 'Error al eliminar pregunta' });
                }
            }
        });
    };

    return (
        <Box sx={{ p: 2 }}>
            <Stack spacing={2}>
                {puntosInspeccion.map((formulario) => (
                    <Accordion
                        key={formulario.id_formulario}
                        expanded={expandedFormulario === formulario.id_formulario}
                        onChange={handleFormularioChange(formulario.id_formulario)}
                    >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Box>
                                <Typography variant="h6">{formulario.nombre_formulario}</Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {formulario.descripcion}
                                </Typography>
                            </Box>
                        </AccordionSummary>

                        <AccordionDetails>
                            <Stack spacing={2}>
                                {formulario.temas.map((tema) => (
                                    <Accordion
                                        key={tema.id_tema}
                                        expanded={expandedTema === tema.id_tema}
                                        onChange={handleTemaChange(tema.id_tema)}
                                    >
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography variant="subtitle1">{tema.nombre_tema}</Typography>
                                        </AccordionSummary>

                                        <AccordionDetails>
                                            <Stack spacing={2}>
                                                {tema.preguntas.length === 0 ? (
                                                    <Typography variant="body2" color="text.secondary">
                                                        No hay preguntas registradas para este tema.
                                                    </Typography>
                                                ) : (
                                                    tema.preguntas.map((pregunta) => (
                                                        <Card key={pregunta.id_pregunta} variant="outlined">
                                                            <CardContent>
                                                                <Typography variant="body1">{pregunta.texto_pregunta}</Typography>
                                                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                                                    Tipo: {pregunta.tipo_pregunta} | Obligatoria: {pregunta.es_obligatoria ? 'Sí' : 'No'} | Foto: {pregunta.requiere_foto ? 'Sí' : 'No'} | Nota: {pregunta.permite_nota ? 'Sí' : 'No'}
                                                                </Typography>

                                                                {pregunta.opciones_respuesta && (
                                                                    <Box sx={{ mb: 1 }}>
                                                                        <Typography variant="subtitle2">Respuestas:</Typography>
                                                                        <ul style={{ margin: 0, paddingLeft: 20 }}>
                                                                            {pregunta.opciones_respuesta.split('|').map((r, i) => (
                                                                                <li key={i}>{r}</li>
                                                                            ))}
                                                                        </ul>
                                                                    </Box>
                                                                )}

                                                                <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                                                                    <IconButton
                                                                        size="medium"
                                                                        onClick={() => handleEditPregunta(pregunta, tema.imagen_url, tema)}
                                                                    >
                                                                        <EditIcon fontSize="small" />
                                                                    </IconButton>
                                                                    <IconButton
                                                                        size="medium"
                                                                        onClick={() => handleDeletePregunta(pregunta)}
                                                                    >
                                                                        <DeleteIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Stack>
                                                            </CardContent>
                                                        </Card>
                                                    ))
                                                )}
                                            </Stack>
                                        </AccordionDetails>
                                    </Accordion>
                                ))}
                            </Stack>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Stack>

            <ModalEditarPregunta
                open={open}
                onClose={handleClose}
                selectedPregunta={selectedPregunta}
                imagenTema={imagenTema}
                refresh={refresh}
            />
        </Box>
    );
};

export default DashboardPuntosInspeccion;